<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { WeixinShare } from '@/utils/wx'

export default {

  name: 'App',
  data() {
    return {
      
    }
  },
  computed: {
  
  },
  mounted(){
  },
  methods: {
  

  }
}
</script>
<style lang="scss">
</style>
